import { Injectable } from '@angular/core';
import { Upload } from '../../models/upload';
import { environment } from '../../../../environments/environment';
import { TokenIssueService } from '../token-issue/token-issue.service';

@Injectable()
export class UploadFileService {
  uploads: any;
  apiUrl = environment.GOCAR_HELPER_API_URL;
  private gocarHelperTokenTmp: string = '';
  private tokenExpiryTime: number = 0;

  constructor(private tokenIssueService: TokenIssueService) { }

  startUploadingImage(fileUpload: any, path: any) {
    return new Promise((res, rej) => {
      if (fileUpload) {
        this.uploadToGCP(fileUpload, path).then((result: any) => {
          if (result) {
            res({ url: result })
          } else {
            res('')
          }
        }).catch(err => {
          rej(false)
        });
      } else {
        rej(false)
      }
    })
  }

  /**
   * Call backend to upload file to GCP
   * @param fileUpload 
   * @param filePath path of folder, dont include filename bcoz it was generated by server
   * @returns a downloadable url
   */
  async uploadToGCP(fileUpload: Upload, path?: string) {
    // Ensure we have a valid token before making the request
    try {
      await this.ensureValidToken();
    } catch (error) {
      return Promise.reject(error);
    }

    return new Promise((resolve, reject) => {
      let formData = new FormData();
      formData.append('file', fileUpload.file);

      const url = `${this.apiUrl}/storages/upload?path=${path}`;
      var xhr = new XMLHttpRequest();
      xhr.open('post', url, true);
      xhr.setRequestHeader('Authorization', `Bearer ${this.gocarHelperTokenTmp}`);
      xhr.responseType = 'json';

      xhr.onreadystatechange = function (a) {
        if (xhr.readyState == XMLHttpRequest.DONE) {
          try {
            resolve(xhr.response.data);
          } catch (error) {
            reject('Cannot upload');
          }
        }
      }

      xhr.onerror = function (e) {
        console.log('Error');
        console.log(e);
      };
      xhr.onload = function () {
        console.log(this.statusText);
      };

      xhr.send(formData);

    });
  }

  /**
   * Ensure valid token exists before making request
   * @returns Promise that resolves when valid token is available
   */
  private async ensureValidToken(): Promise<void> {
    if (!this.isTokenValid()) {
      await this.fetchNewToken();
    }
  }

  /**
   * Check if token is valid and not expired
   * @returns true if token is valid and not expired
   */
  private isTokenValid(): boolean {
    if (!this.gocarHelperTokenTmp) return false;

    const currentTime = Date.now();
    // Check if token is still valid (expiryTime is already in milliseconds)
    return this.tokenExpiryTime > currentTime;
  }

  /**
   * Fetch new token from API
   * @returns Promise that resolves when token is fetched
   */
  private async fetchNewToken(): Promise<void> {
    try {
      const result: any = await this.tokenIssueService.generateGoCarHelperToken().toPromise();

      if (result && result.data) {
        this.gocarHelperTokenTmp = result.data.token;
        this.tokenExpiryTime = result.data.expiryAfterInMillisecond;
      } else {
        throw new Error('Sorry, unable to upload at this time. Please try again later.');
      }
    } catch (error) {
      console.error('Error fetching token:', error);
      throw error;
    }
  }
}
